// Original flat illustrations, one per letter word. viewBox 0 0 120 120.
const INK = '#2B2D42';
const S = `stroke="${INK}" stroke-width="3" stroke-linejoin="round" stroke-linecap="round"`;
const SH = rx => `<ellipse cx="60" cy="112" rx="${rx}" ry="5" fill="#000" opacity=".07"/>`;
const EYE = (x, y, r = 3.6) => `<circle cx="${x}" cy="${y}" r="${r}" fill="${INK}"/><circle cx="${x + 1.2}" cy="${y - 1.2}" r="${r / 3}" fill="#fff"/>`;
const BLUSH = (x, y) => `<ellipse cx="${x}" cy="${y}" rx="5" ry="3" fill="#FF9FB0" opacity=".85"/>`;
const SMILE = (x, y, w = 8) => `<path d="M${x - w / 2} ${y} q${w / 2} ${w / 2} ${w} 0" fill="none" ${S} stroke-width="2.6"/>`;
// Thick outlined stroke (legs, tails, stems)
const LIMB = (d, c) => `<path d="${d}" fill="none" stroke="${INK}" stroke-width="9" stroke-linecap="round"/><path d="${d}" fill="none" stroke="${c}" stroke-width="3.5" stroke-linecap="round"/>`;
// Cloud-like puff shapes with a single outer outline
const PUFF = (circles, fill) =>
  circles.map(([x, y, r]) => `<circle cx="${x}" cy="${y}" r="${r}" fill="${fill}" ${S}/>`).join('') +
  circles.map(([x, y, r]) => `<circle cx="${x}" cy="${y}" r="${r - 1.6}" fill="${fill}"/>`).join('');
function starPath(cx, cy, R, r) {
  let d = '';
  for (let k = 0; k < 10; k++) {
    const a = (-90 + k * 36) * Math.PI / 180, rad = k % 2 ? r : R;
    d += (k ? 'L' : 'M') + (cx + rad * Math.cos(a)).toFixed(1) + ' ' + (cy + rad * Math.sin(a)).toFixed(1);
  }
  return d + 'Z';
}
const svg = body => `<svg viewBox="0 0 120 120">${body}</svg>`;

const ART = {
  rabbit: svg(`${SH(34)}
    <ellipse cx="44" cy="34" rx="11" ry="30" fill="#fff" ${S} transform="rotate(-10 44 34)"/>
    <ellipse cx="44" cy="36" rx="5" ry="21" fill="#FFB3C1" transform="rotate(-10 44 36)"/>
    <ellipse cx="76" cy="34" rx="11" ry="30" fill="#fff" ${S} transform="rotate(10 76 34)"/>
    <ellipse cx="76" cy="36" rx="5" ry="21" fill="#FFB3C1" transform="rotate(10 76 36)"/>
    <ellipse cx="60" cy="90" rx="30" ry="22" fill="#fff" ${S}/>
    <circle cx="60" cy="72" r="28" fill="#fff" ${S}/>
    ${EYE(50, 70)}${EYE(70, 70)}${BLUSH(42, 80)}${BLUSH(78, 80)}
    <path d="M56 78 h8 l-4 4 z" fill="#FF7A8A"/>
    <path d="M60 82 q-4 5 -8 3 M60 82 q4 5 8 3" fill="none" ${S} stroke-width="2.4"/>`),

  duck: svg(`${SH(38)}
    <path d="M22 78 q0 -22 30 -22 h22 q26 0 26 22 q0 26 -38 26 q-40 0 -40 -26z" fill="#FFD23F" ${S}/>
    <path d="M14 70 q6 10 14 8" fill="#FFD23F" ${S}/>
    <path d="M46 78 q14 14 30 0" fill="#F7B801" ${S}/>
    <circle cx="78" cy="40" r="22" fill="#FFD23F" ${S}/>
    <path d="M96 42 q16 -2 18 6 q-6 8 -20 4z" fill="#FF8C42" ${S}/>
    ${EYE(82, 36, 3.8)}${BLUSH(72, 48)}`),

  apple: svg(`${SH(32)}
    <path d="M60 40 C44 28 20 36 20 62 C20 88 40 106 54 104 C57 103 58 101 60 101 C62 101 63 103 66 104 C80 106 100 88 100 62 C100 36 76 28 60 40Z" fill="#FF5A5F" ${S}/>
    <path d="M60 40 Q60 28 66 18" fill="none" ${S}/>
    <path d="M64 30 Q76 14 92 20 Q82 36 64 30Z" fill="#3BB273" ${S}/>
    <ellipse cx="36" cy="58" rx="6" ry="11" fill="#fff" opacity=".55" transform="rotate(20 36 58)"/>
    ${EYE(50, 70)}${EYE(70, 70)}${SMILE(60, 80)}${BLUSH(42, 80)}${BLUSH(78, 80)}`),

  fox: svg(`${SH(30)}
    <path d="M22 26 L44 42 L76 42 L98 26 L94 62 Q86 90 60 100 Q34 90 26 62Z" fill="#FF8C42" ${S}/>
    <path d="M29 36 L40 44 L32 52Z" fill="${INK}"/><path d="M91 36 L80 44 L88 52Z" fill="${INK}"/>
    <path d="M27 62 Q46 62 60 100 Q34 90 27 62Z" fill="#fff" ${S}/>
    <path d="M93 62 Q74 62 60 100 Q86 90 93 62Z" fill="#fff" ${S}/>
    ${EYE(46, 62)}${EYE(74, 62)}
    <ellipse cx="60" cy="93" rx="5.5" ry="3.8" fill="${INK}"/>`),

  camel: svg(`${SH(42)}
    ${LIMB('M36 76 V102 M48 76 V102', '#E3B27C')}${LIMB('M72 76 V102 M84 76 V102', '#E3B27C')}
    ${LIMB('M26 64 Q16 70 20 82', '#E3B27C')}
    <path d="M24 78 Q22 54 38 52 Q46 30 57 50 Q66 30 76 50 Q92 52 92 78 Z" fill="#E3B27C" ${S}/>
    <path d="M86 66 Q94 52 92 36 Q92 24 103 24 Q114 24 114 34 Q114 41 106 41 Q100 41 100 47 Q100 62 92 74Z" fill="#E3B27C" ${S}/>
    ${EYE(104, 31, 2.8)}`),

  whale: svg(`${SH(40)}
    <path d="M46 40 Q42 26 32 24 M46 40 Q46 26 46 16 M46 40 Q50 26 60 24" fill="none" stroke="#4D9DE0" stroke-width="4" stroke-linecap="round"/>
    <path d="M10 72 Q10 44 48 44 Q86 44 94 66 L108 52 Q114 68 106 76 Q116 84 110 96 L94 84 Q84 100 48 100 Q10 100 10 72Z" fill="#4D9DE0" ${S}/>
    <path d="M17 84 Q40 100 78 92 Q62 98 48 98 Q24 98 17 84Z" fill="#BFE0FA"/>
    ${EYE(34, 66)}${SMILE(24, 78, 10)}${BLUSH(42, 76)}`),

  sheep: svg(`${SH(38)}
    ${LIMB('M42 88 V104 M56 90 V104 M70 90 V104 M82 88 V104', '#4A4E69')}
    ${PUFF([[40, 60, 16], [60, 52, 18], [78, 58, 16], [30, 76, 14], [88, 76, 14], [46, 86, 16], [72, 86, 16], [60, 72, 22]], '#fff')}
    <ellipse cx="93" cy="54" rx="9" ry="5" fill="#4A4E69" ${S} transform="rotate(25 93 54)"/>
    <ellipse cx="84" cy="64" rx="14" ry="17" fill="#4A4E69" ${S}/>
    <circle cx="79" cy="61" r="3.2" fill="#fff"/><circle cx="90" cy="61" r="3.2" fill="#fff"/>
    <circle cx="79" cy="61.5" r="1.6" fill="${INK}"/><circle cx="90" cy="61.5" r="1.6" fill="${INK}"/>
    ${PUFF([[78, 46, 7], [86, 44, 7]], '#fff')}`),

  bear: svg(`${SH(32)}
    <ellipse cx="60" cy="94" rx="28" ry="16" fill="#A0673F" ${S}/>
    <circle cx="36" cy="34" r="12" fill="#A0673F" ${S}/><circle cx="36" cy="34" r="6" fill="#E8B48A"/>
    <circle cx="84" cy="34" r="12" fill="#A0673F" ${S}/><circle cx="84" cy="34" r="6" fill="#E8B48A"/>
    <circle cx="60" cy="60" r="30" fill="#A0673F" ${S}/>
    <ellipse cx="60" cy="71" rx="14" ry="10" fill="#E8B48A"/>
    <ellipse cx="60" cy="66" rx="5" ry="3.5" fill="${INK}"/>
    <path d="M60 69 v4 M54 75 q6 4 12 0" fill="none" ${S} stroke-width="2.4"/>
    ${EYE(48, 54)}${EYE(72, 54)}${BLUSH(40, 68)}${BLUSH(80, 68)}`),

  corn: svg(`${SH(24)}
    <path d="M60 12 C76 12 80 40 78 64 C76 86 68 98 60 98 C52 98 44 86 42 64 C40 40 44 12 60 12Z" fill="#FFD23F" ${S}/>
    <g stroke="#E8A317" stroke-width="2" fill="none" stroke-linecap="round">
      <path d="M45 28 Q60 31 75 28 M44 40 Q60 43 76 40 M43 52 Q60 55 77 52 M43 64 Q60 67 77 64 M45 76 Q60 79 75 76"/>
      <path d="M52 16 Q49 54 52 90 M60 13 V96 M68 16 Q71 54 68 90"/>
    </g>
    <path d="M60 106 C38 102 26 80 28 50 C40 68 50 84 60 106Z" fill="#7BC67E" ${S}/>
    <path d="M60 106 C82 102 94 80 92 50 C80 68 70 84 60 106Z" fill="#5DB862" ${S}/>`),

  pomegranate: svg(`${SH(34)}
    <circle cx="60" cy="66" r="38" fill="#E5384F" ${S}/>
    <path d="M47 33 L43 16 L53 24 L60 12 L67 24 L77 16 L73 33Z" fill="#C2185B" ${S}/>
    <ellipse cx="42" cy="54" rx="6" ry="10" fill="#fff" opacity=".5" transform="rotate(30 42 54)"/>
    ${EYE(50, 68)}${EYE(70, 68)}${SMILE(60, 78)}${BLUSH(42, 78)}${BLUSH(78, 78)}`),

  giraffe: svg(`${SH(30)}
    ${LIMB('M42 88 V106 M52 90 V106 M68 90 V106 M78 88 V106', '#FFC94A')}
    ${LIMB('M34 78 Q24 82 24 94', '#FFC94A')}
    <path d="M72 76 L80 30 L94 30 L86 78Z" fill="#FFC94A" ${S}/>
    <ellipse cx="60" cy="80" rx="28" ry="14" fill="#FFC94A" ${S}/>
    <path d="M84 16 L81 6 M96 16 L99 6" ${S} stroke-width="3"/>
    <circle cx="81" cy="6" r="3.5" fill="#C97B2C"/><circle cx="99" cy="6" r="3.5" fill="#C97B2C"/>
    <ellipse cx="91" cy="26" rx="17" ry="11" fill="#FFC94A" ${S}/>
    <ellipse cx="102" cy="30" rx="6" ry="4.5" fill="#F4B266"/>
    <g fill="#C97B2C"><circle cx="46" cy="78" r="5"/><circle cx="62" cy="74" r="4"/><circle cx="74" cy="84" r="4"/><circle cx="54" cy="88" r="3"/><circle cx="83" cy="48" r="3.2"/><circle cx="85" cy="62" r="3"/></g>
    ${EYE(90, 22, 3)}`),

  fish: svg(`${SH(36)}
    <path d="M44 40 Q56 20 72 38" fill="#FF8C42" ${S}/>
    <path d="M86 62 L112 40 Q104 62 112 84Z" fill="#FF8C42" ${S}/>
    <ellipse cx="54" cy="62" rx="38" ry="26" fill="#FFA94D" ${S}/>
    <path d="M58 50 q7 9 0 18 M72 48 q7 11 0 22 M58 66 q7 8 0 14" fill="none" stroke="#E8762B" stroke-width="2.6" stroke-linecap="round"/>
    ${EYE(32, 56, 4.4)}${SMILE(25, 70, 9)}${BLUSH(40, 68)}`),

  sun: svg(`<g stroke="#F2A21B" stroke-width="7" stroke-linecap="round">
      ${[0, 45, 90, 135, 180, 225, 270, 315].map(a => {
        const r = a * Math.PI / 180;
        return `<line x1="${(60 + 42 * Math.cos(r)).toFixed(1)}" y1="${(60 + 42 * Math.sin(r)).toFixed(1)}" x2="${(60 + 54 * Math.cos(r)).toFixed(1)}" y2="${(60 + 54 * Math.sin(r)).toFixed(1)}"/>`;
      }).join('')}
    </g>
    <circle cx="60" cy="60" r="33" fill="#FFD23F" ${S}/>
    ${EYE(50, 56)}${EYE(70, 56)}${SMILE(60, 68, 12)}${BLUSH(42, 66)}${BLUSH(78, 66)}`),

  rocket: svg(`<g transform="rotate(25 60 60)">
    <path d="M50 92 Q60 120 70 92Z" fill="#FF8C42" ${S}/>
    <path d="M52 92 Q60 108 68 92Z" fill="#FFD23F"/>
    <path d="M45 64 L30 90 L47 88Z" fill="#E5384F" ${S}/>
    <path d="M75 64 L90 90 L73 88Z" fill="#E5384F" ${S}/>
    <path d="M60 8 C80 24 80 70 74 94 L46 94 C40 70 40 24 60 8Z" fill="#fff" ${S}/>
    <path d="M60 8 C68 14 72 22 75 32 L45 32 C48 22 52 14 60 8Z" fill="#E5384F" ${S}/>
    <circle cx="60" cy="56" r="10" fill="#4D9DE0" ${S}/>
    <circle cx="57" cy="53" r="3" fill="#fff" opacity=".8"/>
    </g>
    <g fill="#FFC94A"><path d="${starPath(16, 28, 7, 3)}"/><path d="${starPath(102, 100, 6, 2.6)}"/></g>`),

  frog: svg(`${SH(36)}
    <circle cx="38" cy="44" r="15" fill="#6CC56E" ${S}/><circle cx="82" cy="44" r="15" fill="#6CC56E" ${S}/>
    <path d="M18 78 Q18 48 60 48 Q102 48 102 78 Q102 102 60 102 Q18 102 18 78Z" fill="#6CC56E" ${S}/>
    <circle cx="38" cy="42" r="8" fill="#fff" ${S} stroke-width="2.4"/><circle cx="82" cy="42" r="8" fill="#fff" ${S} stroke-width="2.4"/>
    <circle cx="39" cy="43" r="3.6" fill="${INK}"/><circle cx="83" cy="43" r="3.6" fill="${INK}"/>
    <path d="M36 74 Q60 94 84 74" fill="none" ${S}/>
    ${BLUSH(28, 72)}${BLUSH(92, 72)}`),

  plane: svg(`${SH(42)}
    <path d="M20 52 L14 28 L28 28 L40 52Z" fill="#E5384F" ${S}/>
    <path d="M14 56 Q14 48 24 48 L86 48 Q108 48 110 62 Q108 76 86 76 L26 76 Q14 76 14 66Z" fill="#fff" ${S}/>
    <path d="M90 52 Q102 53 106 60 L90 60Z" fill="#4D9DE0" ${S} stroke-width="2.4"/>
    <g fill="#4D9DE0"><circle cx="38" cy="60" r="4"/><circle cx="52" cy="60" r="4"/><circle cx="66" cy="60" r="4"/></g>
    <path d="M22 70 H100" stroke="#E5384F" stroke-width="3" stroke-linecap="round"/>
    <path d="M48 68 L72 68 L56 98 L42 98Z" fill="#4D9DE0" ${S}/>
    ${PUFF([[100, 22, 8], [110, 24, 6]], '#fff')}`),

  envelope: svg(`${SH(42)}
    <rect x="16" y="30" width="88" height="64" rx="9" fill="#fff" ${S}/>
    <path d="M20 90 L50 62 M100 90 L70 62" fill="none" ${S}/>
    <path d="M18 34 L60 66 L102 34" fill="#F3F0FF" ${S}/>
    <path d="M60 80 C47 72 49 60 55 60 C58 60 60 62 60 65 C60 62 62 60 65 60 C71 60 73 72 60 80Z" fill="#E5384F" ${S} stroke-width="2.4"/>`),

  grapes: svg(`${SH(22)}
    <path d="M62 30 Q62 20 68 12" fill="none" ${S}/>
    <path d="M65 24 Q80 8 96 18 Q84 34 65 24Z" fill="#3BB273" ${S}/>
    ${[[46, 40], [62, 38], [78, 40], [38, 56], [54, 56], [70, 56], [86, 56], [46, 72], [62, 72], [78, 72], [54, 88], [70, 88], [62, 102]]
      .map(([x, y]) => `<circle cx="${x}" cy="${y}" r="10" fill="#8B5CF6" ${S}/><circle cx="${x - 3}" cy="${y - 3}" r="2.6" fill="#fff" opacity=".6"/>`).join('')}`),

  cloud: svg(`<g fill="#4D9DE0" ${S} stroke-width="2.4">
      <path d="M38 96 q-5 8 0 11 q5 -3 0 -11Z"/><path d="M60 100 q-5 8 0 11 q5 -3 0 -11Z"/><path d="M82 96 q-5 8 0 11 q5 -3 0 -11Z"/>
    </g>
    ${PUFF([[40, 62, 20], [62, 50, 25], [84, 60, 20], [28, 76, 14], [96, 76, 14], [62, 74, 18], [44, 80, 12], [80, 80, 12]], '#fff')}
    ${EYE(52, 66)}${EYE(72, 66)}${SMILE(62, 75)}${BLUSH(44, 74)}${BLUSH(80, 74)}`),

  elephant: svg(`${SH(36)}
    <ellipse cx="28" cy="54" rx="22" ry="26" fill="#A9B4C8" ${S}/><ellipse cx="30" cy="56" rx="12" ry="16" fill="#F4B6C2"/>
    <ellipse cx="92" cy="54" rx="22" ry="26" fill="#A9B4C8" ${S}/><ellipse cx="90" cy="56" rx="12" ry="16" fill="#F4B6C2"/>
    <path d="M52 70 Q50 96 60 104 Q72 110 76 98 Q66 98 66 88 L68 70Z" fill="#A9B4C8" ${S}/>
    <circle cx="60" cy="54" r="28" fill="#A9B4C8" ${S}/>
    <path d="M56 88 h8 M55 96 h7" stroke="#8592AA" stroke-width="2.4" stroke-linecap="round"/>
    ${EYE(48, 52)}${EYE(72, 52)}${BLUSH(42, 64)}${BLUSH(78, 64)}`),

  cat: svg(`${SH(34)}
    ${LIMB('M80 98 Q104 96 98 70', '#FFA94D')}
    <ellipse cx="60" cy="94" rx="24" ry="14" fill="#FFA94D" ${S}/>
    <path d="M34 50 L31 20 L55 38Z" fill="#FFA94D" ${S}/><path d="M38 42 L37 30 L46 38Z" fill="#FFB3C1"/>
    <path d="M86 50 L89 20 L65 38Z" fill="#FFA94D" ${S}/><path d="M82 42 L83 30 L74 38Z" fill="#FFB3C1"/>
    <ellipse cx="60" cy="60" rx="31" ry="26" fill="#FFA94D" ${S}/>
    <path d="M60 35 v8 M52 37 v6 M68 37 v6" stroke="#E8762B" stroke-width="3" stroke-linecap="round"/>
    ${EYE(48, 58)}${EYE(72, 58)}
    <path d="M57 66 h6 l-3 3z" fill="#FF7A8A"/>
    <path d="M60 69 q-3 4 -7 2 M60 69 q3 4 7 2" fill="none" ${S} stroke-width="2.2"/>
    <path d="M40 66 L24 63 M40 70 L24 72 M80 66 L96 63 M80 70 L96 72" stroke="${INK}" stroke-width="1.8" stroke-linecap="round"/>`),

  cake: svg(`<ellipse cx="60" cy="102" rx="46" ry="7" fill="#fff" ${S}/>
    <rect x="24" y="56" width="72" height="44" rx="8" fill="#F7D9A8" ${S}/>
    <path d="M24 64 Q24 52 34 52 H86 Q96 52 96 64 Q96 74 90 72 Q86 70 84 76 Q80 82 76 74 Q72 68 66 74 Q60 82 54 74 Q48 68 44 76 Q40 82 36 74 Q32 68 28 72 Q24 74 24 64Z" fill="#F48FB1" ${S}/>
    <g stroke-width="3.2" stroke-linecap="round"><path d="M38 86 l4 -3" stroke="#4D9DE0"/><path d="M54 92 l4 2" stroke="#FFC94A"/><path d="M70 86 l4 -2" stroke="#3BB273"/><path d="M82 92 l3 3" stroke="#8B5CF6"/></g>
    <rect x="56" y="30" width="8" height="22" rx="3" fill="#4D9DE0" ${S}/>
    <path d="M60 12 Q69 23 60 28 Q51 23 60 12Z" fill="#FFC94A" ${S}/>`),

  lemon: svg(`${SH(38)}
    <path d="M16 64 Q14 56 22 54 Q34 30 64 32 Q92 34 100 54 Q108 56 106 64 Q104 72 96 72 Q84 94 56 92 Q30 90 24 74 Q16 72 16 64Z" fill="#FFE14D" ${S}/>
    <path d="M66 32 Q72 14 92 14 Q86 32 66 32Z" fill="#3BB273" ${S}/>
    <ellipse cx="40" cy="52" rx="8" ry="4" fill="#fff" opacity=".6" transform="rotate(-20 40 52)"/>
    ${EYE(50, 62)}${EYE(70, 62)}${SMILE(60, 72)}${BLUSH(42, 72)}${BLUSH(78, 72)}`),

  banana: svg(`${SH(38)}
    <path d="M23 32 L21 20 L29 20 L31 32Z" fill="#8D6E3F" ${S}/>
    <path d="M20 40 Q28 94 80 96 Q102 96 108 84 Q102 80 94 82 Q54 84 36 38 Q32 30 26 31 Q18 33 20 40Z" fill="#FFD23F" ${S}/>
    <path d="M30 46 Q44 82 86 90" fill="none" stroke="#E8A317" stroke-width="2.6" stroke-linecap="round"/>
    ${EYE(46, 64, 3.2)}${EYE(58, 72, 3.2)}`),

  star: svg(`${SH(30)}
    <path d="${starPath(60, 62, 50, 24)}" fill="#FFC94A" ${S} stroke-width="3.4"/>
    ${EYE(51, 62)}${EYE(69, 62)}${SMILE(60, 71)}${BLUSH(44, 72)}${BLUSH(76, 72)}`),

  crescent: svg(`<path d="M74 16 C40 14 16 42 18 68 C20 98 54 112 86 98 C62 96 46 80 46 58 C46 40 56 24 74 16Z" fill="#FFD23F" ${S}/>
    <path d="M24 62 q5 4 10 0" fill="none" ${S} stroke-width="2.6"/>${BLUSH(30, 72)}
    <g fill="#FFC94A" ${S} stroke-width="2.2"><path d="${starPath(86, 40, 11, 5)}"/><path d="${starPath(102, 68, 7, 3.2)}"/></g>
    <circle cx="70" cy="74" r="2.5" fill="#FFC94A"/>`),

  flower: svg(`${LIMB('M60 62 Q57 88 60 110', '#3BB273')}
    <path d="M59 94 Q40 76 30 88 Q44 102 59 94Z" fill="#3BB273" ${S}/>
    <path d="M61 86 Q80 68 90 80 Q76 94 61 86Z" fill="#3BB273" ${S}/>
    ${[0, 60, 120, 180, 240, 300].map(a => {
      const r = a * Math.PI / 180;
      return `<circle cx="${(60 + 20 * Math.cos(r)).toFixed(1)}" cy="${(42 + 20 * Math.sin(r)).toFixed(1)}" r="15" fill="#F48FB1" ${S}/>`;
    }).join('')}
    <circle cx="60" cy="42" r="13" fill="#FFC94A" ${S}/>
    ${EYE(55, 40, 2.4)}${EYE(65, 40, 2.4)}${SMILE(60, 46, 6)}`),

  pumpkin: svg(`${SH(42)}
    <path d="M56 36 Q53 22 61 14 L68 18 Q62 26 64 36Z" fill="#8D6E3F" ${S}/>
    <path d="M66 26 q14 -10 22 2" fill="none" stroke="#3BB273" stroke-width="3" stroke-linecap="round"/>
    <ellipse cx="38" cy="70" rx="24" ry="32" fill="#FF8C42" ${S}/>
    <ellipse cx="82" cy="70" rx="24" ry="32" fill="#FF8C42" ${S}/>
    <ellipse cx="60" cy="70" rx="22" ry="34" fill="#FFA94D" ${S}/>
    ${EYE(52, 66)}${EYE(68, 66)}${SMILE(60, 76)}${BLUSH(46, 76)}${BLUSH(74, 76)}`),
};
